import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core'
import { FormControl, ReactiveFormsModule } from '@angular/forms'
import { ButtonDirective } from 'primeng/button'
import { Select } from 'primeng/select'
import { DetailviewNavigationService } from '@services/detailview-navigation.service'

/**
 * Section select with previous/next buttons for detail views.
 * Uses the DetailviewNavigationService provided by the host detail view.
 */
@Component({
  selector: 'albert-section-navigation',
  standalone: true,
  imports: [ReactiveFormsModule, Select, ButtonDirective],
  templateUrl: './albert-section-navigation.component.html',
  styleUrl: './albert-section-navigation.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlbertSectionNavigationComponent {
  public readonly sectionControl = input.required<FormControl<string | null>>()
  protected readonly nav = inject(DetailviewNavigationService)
}
